"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowNumericEditor_1 = require("../../../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var BonusTournamentMinBetsEditor = /** @class */ (function (_super) {
    __extends(BonusTournamentMinBetsEditor, _super);
    function BonusTournamentMinBetsEditor(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentMinBetsEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    amount: _item.amount,
                    description: _item.description
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Турниры", "Изменить мин сумма ставки турнира"]);
                });
            }
        }
        else {
            this.setState({
                app_currency_id: 0,
                app_currency_title: "",
                amount: 0,
                description: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Турниры", "Добавить мин сумма ставки турнира"]);
            });
        }
        this.doReSetRules();
    };
    BonusTournamentMinBetsEditor.prototype.doReSetRules = function () {
        this.setState({
            app_currency_rules: { isError: false }
        });
    };
    BonusTournamentMinBetsEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({ app_currency_rules: { isError: true, errorMessage: "Валюта не выбрана!" } });
            return false;
        }
        return true;
    };
    BonusTournamentMinBetsEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_currency_id: this.state.app_currency_id,
                bonus_tournament_id: this.props.rootRecord.key,
                amount: this.state.amount,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Мин сумма ставки добавлена!");
            });
        }
    };
    BonusTournamentMinBetsEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                app_currency_id: this.state.app_currency_id,
                key: this.props.record.key,
                amount: this.state.amount,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Мин сумма ставки изменена!");
            });
        }
    };
    BonusTournamentMinBetsEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusTournamentMinBetsEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить мин. сумму ставки";
        }
        else {
            return "Изменить мин. сумму ставки";
        }
    };
    BonusTournamentMinBetsEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BonusTournamentMinBetsEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 370 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта:", placeholder: "Выберите валюту" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false }
                    });
                }, items: this.props.availCurrency, required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Мин. ставка:", placeholder: "Введите сумму минимальной ставки" }, values: { max: 999999, min: 0, value: this.state.amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        amount: newVal
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            this.getDownButtons()));
    };
    return BonusTournamentMinBetsEditor;
}(React.Component));
exports.default = BonusTournamentMinBetsEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/min_bets/BonusTournamentMinBetsEditor.tsx
// module id = 2531
// module chunks = 0